import { actionCreator } from '../../utils/actions';

export const changeCurrentInfoEvent = actionCreator('Messages/CHANGE_CURRENT_INFO_EVENT');
export const filterInfoEvents = actionCreator('Messages/FILTER_INFO_EVENTS');



// WEBPACK FOOTER //
// ./src/components/Messages/actions.js